import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {API_URL} from "lib-base";
import {Observable} from "rxjs";
import {ITipoPoblacion} from "../shared/interfaces/configuracion";

@Injectable({
  providedIn: 'root'
})
export class TipoPoblacionService {
  private baseUrl: string ;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tipo-poblacion`;
  }

  getAll():Observable<ITipoPoblacion[]> {
    return this.http.get<ITipoPoblacion[]>(`${this.baseUrl}/public`);
  }
}
